import {createRoot} from 'react-dom/client';
import {Footer} from './Footer';

const container = document.getElementById('footer');

evite.when(['react']).then(() => {
  if (container) {
    const root = createRoot(container);
    root.render(<Footer />);
  } else {
    console.warn('This page DOM is missing element with id="footer"');
  }
});
